export const API_KEY_LIST_REQUEST = "API_KEY_LIST_REQUEST";
export const API_KEY_LIST_SUCCESS = "API_KEY_LIST_SUCCESS";
export const API_KEY_LIST_FAIL = "API_KEY_LIST_FAIL";

export const API_KEY_CREATE_REQUEST = "API_KEY_CREATE_REQUEST";
export const API_KEY_CREATE_SUCCESS = "API_KEY_CREATE_SUCCESS";
export const API_KEY_CREATE_FAIL = "API_KEY_CREATE_FAIL";
export const API_KEY_CREATE_RESET = "API_KEY_CREATE_RESET";

export const API_KEY_DELETE_REQUEST = "API_KEY_DELETE_REQUEST";
export const API_KEY_DELETE_SUCCESS = "API_KEY_DELETE_SUCCESS";
export const API_KEY_DELETE_FAIL = "API_KEY_DELETE_FAIL";